import React from 'react';
import { Chart } from 'react-chartjs-2';
import { type ChartData } from 'chart.js';
import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import { numberFormatter } from '~library/numbers';
import { getXAxisConfig } from '../Chart';
import { useIsPrinting } from '~library/print';

export const MAIN_CHART_ID = 'pages-rendered-main-chart';

type PagesRenderedMainChartProps = {
  labels: string[];
  datasets: ChartData<'bar', number[], string>['datasets'];
  granularity: AggregatedMetrics.IntervalGranularity;
};
function PagesRenderedMainChart({ labels, datasets, granularity }: PagesRenderedMainChartProps) {
  const { isPrinting } = useIsPrinting();
  return (
    <Chart
      id={MAIN_CHART_ID}
      type="bar"
      data={{ labels, datasets }}
      options={{
        animation: isPrinting ? false : undefined,
        scales: {
          x: getXAxisConfig(granularity),
          y: {
            type: 'linear',
            ticks: {
              count: 5,
              callback: (value) => numberFormatter.format(Number(value)),
            },
          },
        },
      }}
    />
  );
}

export default PagesRenderedMainChart;
